import React from "react";
import { CssBaseline, GlobalStyles } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles"; // <-- Fixed import path
import { theme } from "./theme";

import Navigation from "./components/Layout/Navigation";
import Footer from "./components/Layout/Footer";
import Hero from "./components/Sections/Hero";
import Expertise from "./components/Sections/Expertise";
import Works from "./components/Sections/Works";
// import Ecosystem from "./components/Sections/Ecosystem";
import Experience from "./components/Sections/Experience";
import Insights from "./components/Sections/Insights";
import Skills from "./components/Sections/Skills";
// import MouseSpotlight from "./components/UI/MouseSpotlight";
import MouseBackground from "./components/UI/MouseBackground";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          html: {
            scrollBehavior: "smooth",
            overflowX: "hidden", // Prevent horizontal wiggle
          },
          body: {
            backgroundColor: "#0a0a0c",
            color: "#f8fafc",
            WebkitFontSmoothing: "antialiased",
            fontFamily: '"Inter", sans-serif',
            overflowX: "hidden", // Prevent horizontal wiggle
            width: "100%",
          },
          "::selection": {
            backgroundColor: "rgba(0, 240, 255, 0.3)",
            color: "white",
          },
          "@keyframes pulse-slow": {
            "0%, 100%": { opacity: 1 },
            "50%": { opacity: 0.5 },
          },
          "@keyframes bounce": {
            "0%, 100%": {
              transform: "translateY(-25%)",
              animationTimingFunction: "cubic-bezier(0.8,0,1,1)",
            },
            "50%": {
              transform: "translateY(0)",
              animationTimingFunction: "cubic-bezier(0,0,0.2,1)",
            },
          },
        }}
      />
      <MouseBackground />
      <Navigation />

      <main>
        <Hero />
        <Expertise />
        <Works />
        {/* <Ecosystem /> */}
        <Experience />
        <Insights />
        <Skills />
      </main>

      <Footer />
    </ThemeProvider>
  );
}

export default App;
